<template>
  <v-card flat class="ai-chat-settings">
    <custom-tabs v-model="activeTab" grow>
      <template v-slot:staticTabs>
        <v-tab :ripple="false">
          <div class="cornel-left" />
          <div class="cornel-right" />
          <div class="d-flex align-center">
            <v-icon class="me-2">mdi-palette</v-icon>
            تنظیمات ظاهری
          </div>
        </v-tab>

        <v-tab :ripple="false">
          <div class="cornel-left" />
          <div class="cornel-right" />
          <div class="d-flex align-center">
            <v-icon class="me-2">mdi-account-outline</v-icon>
            اتصال به مشتریان (لید)
          </div>
        </v-tab>
      </template>

      <template v-slot:middle>
        <div class="py-3" />
      </template>

      <template v-slot:staticItems>
        <v-tab-item>
          <v-card flat class="pa-2">
            <v-expansion-panels v-model="openPanel" accordion flat>
              <v-expansion-panel class="settings-panel mb-3">
                <v-expansion-panel-header class="settings-panel-header">
                  <div class="d-flex align-center">
                    <v-avatar size="36" color="primary" class="ml-3">
                      <v-icon color="white" small
                        >mdi-page-layout-header</v-icon
                      >
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold">تنظیمات هدر چت</div>
                      <div class="text-caption grey--text">
                        رنگ و استایل نوار بالای پنجره گفتگو
                      </div>
                    </div>
                  </div>
                  <template v-slot:actions>
                    <v-icon color="primary">mdi-chevron-down</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pt-4">
                  <v-switch
                    v-model="computedValue.chatSettings.headerGradient"
                    :label="
                      computedValue.chatSettings.headerGradient
                        ? 'رنگ گرادیان (Gradient)'
                        : 'تک رنگ'
                    "
                    dense
                    inset
                    color="primary"
                    class="mb-4"
                    @change="emitUpdate"
                  />

                  <v-row v-if="computedValue.chatSettings.headerGradient">
                    <v-col cols="12" md="6">
                      <color-picker
                        v-model="computedValue.chatSettings.headerColor"
                        label="رنگ اول"
                        @input="emitUpdate"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <color-picker
                        v-model="computedValue.chatSettings.headerColor2"
                        label="رنگ دوم"
                        @input="emitUpdate"
                      />
                    </v-col>
                  </v-row>

                  <color-picker
                    v-else
                    v-model="computedValue.chatSettings.headerColor"
                    label="رنگ اصلی هدر"
                    @input="emitUpdate"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel class="settings-panel mb-3">
                <v-expansion-panel-header class="settings-panel-header">
                  <div class="d-flex align-center">
                    <v-avatar size="36" color="deep-purple" class="ml-3">
                      <v-icon color="white" small>mdi-format-text</v-icon>
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold">تنظیمات متن و فونت</div>
                      <div class="text-caption grey--text">
                        تغییر اندازه و رنگ پیام‌های داخل چت
                      </div>
                    </div>
                  </div>
                  <template v-slot:actions>
                    <v-icon color="deep-purple">mdi-chevron-down</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pt-4">
                  <color-picker
                    v-model="computedValue.chatSettings.textColor"
                    label="رنگ متن"
                    @input="emitUpdate"
                  />

                  <div class="mt-4">
                    <v-slider
                      v-model="computedValue.chatSettings.fontSize"
                      :min="12"
                      :max="20"
                      :step="1"
                      thumb-label="always"
                      label="اندازه فونت"
                      color="deep-purple"
                      track-color="grey lighten-2"
                      @input="emitUpdate"
                    >
                      <template v-slot:append>
                        <span class="text-body-2">
                          {{ computedValue.chatSettings.fontSize }} پیکسل
                        </span>
                      </template>
                    </v-slider>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel class="settings-panel mb-3">
                <v-expansion-panel-header class="settings-panel-header">
                  <div class="d-flex align-center">
                    <v-avatar size="36" color="teal" class="ml-3">
                      <v-icon color="white" small>mdi-image</v-icon>
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold">لوگو /آیکون</div>
                      <div class="text-caption grey--text">
                        آیکون گوشه صفحه و تصویر آواتار دستیار
                      </div>
                    </div>
                  </div>
                  <template v-slot:actions>
                    <v-icon color="teal">mdi-chevron-down</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pt-4">
                  <v-switch
                    v-model="computedValue.chatSettings.useImageLogo"
                    :label="
                      computedValue.chatSettings.useImageLogo
                        ? 'استفاده از تصویر اختصاصی'
                        : 'استفاده از آیکون '
                    "
                    dense
                    inset
                    color="teal"
                    class="mb-4"
                    @change="emitUpdate"
                  />

                  <pic-selector
                    v-if="computedValue.chatSettings.useImageLogo"
                    :field="computedValue.chatSettings.chatLogo"
                    @update:field="updateLogoImage"
                    :edit-name="false"
                    default-cat-name="انتخاب لوگو"
                    one-pic
                    single
                  />

                  <div v-else>
                    <v-select
                      v-model="computedValue.chatSettings.floatingIcon"
                      :items="floatingIcons"
                      item-text="text"
                      item-value="value"
                      label="انتخاب آیکون"
                      outlined
                      dense
                      @change="emitUpdate"
                    >
                      <template v-slot:selection="{ item }">
                        <v-icon class="ml-2" color="teal">{{
                          item.value
                        }}</v-icon>
                        {{ item.text }}
                      </template>
                      <template v-slot:item="{ item }">
                        <v-icon class="ml-2">{{ item.value }}</v-icon>
                        {{ item.text }}
                      </template>
                    </v-select>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel class="settings-panel mb-3">
                <v-expansion-panel-header class="settings-panel-header">
                  <div class="d-flex align-center">
                    <v-avatar size="36" color="orange" class="ml-3">
                      <v-icon color="white" small>mdi-palette-swatch</v-icon>
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold">پس‌زمینه چت</div>
                      <div class="text-caption grey--text">
                        رنگ یا تصویر پشت زمینه پیام‌ها
                      </div>
                    </div>
                  </div>
                  <template v-slot:actions>
                    <v-icon color="orange">mdi-chevron-down</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pt-4">
                  <v-switch
                    v-model="computedValue.chatSettings.useImageBackground"
                    :label="
                      computedValue.chatSettings.useImageBackground
                        ? 'استفاده از عکس برای پس‌زمینه'
                        : 'استفاده از رنگ'
                    "
                    dense
                    inset
                    color="orange"
                    class="mb-4"
                    @change="emitUpdate"
                  />

                  <pic-selector
                    v-if="computedValue.chatSettings.useImageBackground"
                    :field="computedValue.chatSettings.backgroundImage"
                    @update:field="updateBackgroundImage"
                    :edit-name="false"
                    default-cat-name="انتخاب تصویر زمینه"
                    one-pic
                    single
                  />

                  <v-switch
                    v-else
                    v-model="computedValue.chatSettings.backGradient"
                    :label="
                      computedValue.chatSettings.backGradient
                        ? 'رنگ گرادیان (Gradient)'
                        : 'تک رنگ'
                    "
                    dense
                    inset
                    color="primary"
                    class="mb-4"
                    @change="emitUpdate"
                  />

                  <v-row v-if="computedValue.chatSettings.backGradient">
                    <v-col cols="12" md="6">
                      <color-picker
                        v-model="computedValue.chatSettings.backColor"
                        label="رنگ اول"
                        @input="emitUpdate"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <color-picker
                        v-model="computedValue.chatSettings.backColor2"
                        label="رنگ دوم"
                        @input="emitUpdate"
                      />
                    </v-col>
                  </v-row>

                  <color-picker
                    v-else
                    v-model="computedValue.chatSettings.backColor"
                    label="انتخاب رنگ پس‌زمینه"
                    @input="emitUpdate"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>
        </v-tab-item>

        <v-tab-item>
          <v-card flat class="pa-4">
            <v-card-subtitle class="font-weight-bold mb-4">
              دریافت اطلاعات مشتریان (Leads)
            </v-card-subtitle>

            <v-alert type="info" border="left" colored-border>
              در این قسمت مشخص کنید که دستیار قبل از شروع گفتگو، چه فیلدهایی را
              به عنوان فرم ورود از کاربر دریافت کند.
            </v-alert>

            <v-card class="chat-preview-window rounded-xl elevation-8 pa-4">
              <v-switch
                class="px-1"
                v-model="computedValue.hasAssistantsName"
                dense
                inset
                label="دریافت نام"
                hint="در ابتدای چت نام کاربر پرسیده شود"
                @change="emitLeadSettingsUpdate"
                persistent-hint
              />
              <v-switch
                class="px-1"
                v-model="computedValue.hasAssistantsFamily"
                dense
                inset
                label="دریافت نام خانوادگی"
                hint="در ابتدای چت فامیلی کاربر پرسیده شود"
                @change="emitLeadSettingsUpdate"
                persistent-hint
              />
              <v-switch
                class="px-1"
                v-model="computedValue.hasAssistantsMobile"
                dense
                inset
                label="دریافت شماره موبایل"
                hint="فیلد اجباری برای دریافت شماره تماس"
                @change="emitLeadSettingsUpdate"
                persistent-hint
              />
            </v-card>
          </v-card>
        </v-tab-item>
      </template>
    </custom-tabs>
  </v-card>
</template>

<script>
import ColorPicker from "@/view/pages/aiDesign/components/cm/colorPicker.vue";
// import PicSelector from "@/view/pages/image/picSelector.vue";
import PicSelector from "../../../components/UploadCenter/picSelector.vue";

export default {
  name: "aiChatSettings",

  components: {
    ColorPicker,
    PicSelector,
  },

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      openPanel: false,
      activeTab: 0,
    };
  },

  computed: {
    computedValue: {
      get() {
        const defaults = {
          assistantName: "",
          assistantId: null,
          assistant: null,
          hasAssistantsName: false,
          hasAssistantsFamily: false,
          hasAssistantsMobile: false,
          chatSettings: {
            headerColor: "#667eea",
            headerColor2: "#764ba2",
            headerGradient: true,
            backGrandient: true,
            backColor: "#ffffff",
            backColor2: "#EA667C",
            // backgroundColor: "#ffffff",
            backgroundImage: null,
            useImageBackground: false,
            textColor: "#333333",
            fontSize: 14,
            chatLogo: null,
            floatingIcon: "mdi-robot",
            useImageLogo: false,
          },
        };
        return {
          ...defaults,
          ...this.value,
          chatSettings: {
            ...defaults.chatSettings,
            ...(this.value?.chatSettings || {}),
          },
        };
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    floatingIcons() {
      return [
        { value: "mdi-robot", text: "ربات هوشمند" },
        { value: "mdi-chat", text: "گفتگو" },
        { value: "mdi-headset", text: "پشتیبانی" },
        { value: "mdi-help-circle", text: "سوال" },
        { value: "mdi-message", text: "پیام" },
        { value: "mdi-account-voice", text: "دستیار صوتی" },
        { value: "mdi-brain", text: "مغز هوشمند" },
      ];
    },
  },

  methods: {
    updateLogoImage(val) {
      const newSettings = {
        ...this.computedValue.chatSettings,
        chatLogo: val,
      };
      this.$emit("input", { ...this.value, chatSettings: newSettings });
    },

    updateBackgroundImage(val) {
      const newSettings = {
        ...this.computedValue.chatSettings,
        backgroundImage: val,
      };
      this.$emit("input", { ...this.value, chatSettings: newSettings });
    },

    emitUpdate() {
      this.$emit("input", {
        ...this.value,
        chatSettings: { ...this.computedValue.chatSettings },
      });
    },
    emitLeadSettingsUpdate() {
      this.$emit("input", {
        ...this.value,
        hasAssistantsName: this.computedValue.hasAssistantsName,
        hasAssistantsFamily: this.computedValue.hasAssistantsFamily,
        hasAssistantsMobile: this.computedValue.hasAssistantsMobile,
        chatSettings: { ...this.computedValue.chatSettings },
      });
    },
    onAssistantChange(assistant) {
      if (assistant) {
        const newValue = {
          ...this.value,
          assistant: assistant,
          assistantId: assistant.id,
          chatSettings: { ...this.computedValue.chatSettings },
        };
        this.$emit("input", newValue);
        this.$nextTick(() => {
          this.activeTab = 1;
        });
      } else {
        const newValue = {
          ...this.value,
          assistant: null,
          assistantId: null,
          chatSettings: { ...this.computedValue.chatSettings },
        };
        this.$emit("input", newValue);
      }
    },
  },
};
</script>

<style scoped>
.ai-chat-settings {
  background: transparent;
}

.chat-preview-window {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 8px;
}

.settings-panel {
  border: 1px solid #e0e0e0;
  border-radius: 12px !important;
  overflow: hidden;
  transition: all 0.3s ease;
}

/* .settings-panel:hover {
  border-color: #bdbdbd;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
} */

.settings-panel-header {
  min-height: 64px;
  padding: 12px 16px;
}

.settings-panel.v-expansion-panel--active {
  border-color: var(--v-primary-base);
}
picSelector button {
  width: 100%;
}
/* ==================== Expansion Panels Base Styles ==================== */
::v-deep .v-expansion-panel {
  border-radius: 12px !important;
  margin-bottom: 16px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;
}

/* Header Base Styles */
::v-deep .v-expansion-panel-header {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
  border-bottom: 1px solid #e2e8f0;
  padding: 18px 24px !important;
  min-height: 64px !important;
  border-radius: 12px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent !important;
  position: relative;
}

/* Header Hover State */
::v-deep .v-expansion-panel-header:hover {
  background: linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%) !important;
  transform: translateY(-1px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
}

/* Header Active State */
::v-deep .v-expansion-panel-header--active {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
  border-radius: 12px 12px 0 0 !important;
  transform: translateY(-1px);
}

/* Header Text Base Styles */
::v-deep .v-expansion-panel-header .text-h6 {
  font-size: 1.15rem !important;
  font-weight: 500;
  color: #1e293b;
  letter-spacing: 0.3px;
  transition: all 0.3s ease;
}

/* Icon Base Styles */
::v-deep .v-expansion-panel-header .v-icon {
  transition: all 0.3s ease;
  color: #64748b;
}

::v-deep .v-expansion-panel-header:hover .v-icon {
  transform: scale(1.1);
}

::v-deep .v-expansion-panel-header--active .v-icon {
  transform: scale(1.15);
}

/* Content Styles */
::v-deep .v-expansion-panel-content__wrap {
  padding: 24px !important;
  background-color: #ffffff;
  border-top: 1px solid #e2e8f0;
}

/* ==================== Panel Colors - Border, Text و Icon در Hover/Active ==================== */

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(3)
  .v-expansion-panel-header:hover,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(3)
  .v-expansion-panel-header--active {
  border-color: #10b981 !important;
  box-shadow: 0 12px 32px rgba(16, 185, 129, 0.3) !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(3)
  .v-expansion-panel-header:hover
  .text-h6,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(3)
  .v-expansion-panel-header--active
  .text-h6 {
  color: #10b981 !important;
  font-weight: 700 !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(3)
  .v-expansion-panel-header:hover
  .v-icon,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(3)
  .v-expansion-panel-header--active
  .v-icon {
  color: #10b981 !important;
  background: white !important;
  border-radius: 50% !important;
  border: 4px solid #10b981 !important;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.08);
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(1)
  .v-expansion-panel-header:hover,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(1)
  .v-expansion-panel-header--active {
  border-color: #6366f1 !important;
  box-shadow: 0 12px 32px rgba(99, 102, 241, 0.3) !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(1)
  .v-expansion-panel-header:hover
  .text-h6,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(1)
  .v-expansion-panel-header--active
  .text-h6 {
  color: #6366f1 !important;
  font-weight: 700 !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(1)
  .v-expansion-panel-header:hover
  .v-icon,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(1)
  .v-expansion-panel-header--active
  .v-icon {
  color: #6366f1 !important;
  background: white !important;
  border-radius: 50% !important;
  border: 4px solid #6366f1 !important;
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.08);
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(4)
  .v-expansion-panel-header:hover,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(4)
  .v-expansion-panel-header--active {
  border-color: #f59e0b !important;
  box-shadow: 0 12px 32px rgba(245, 158, 11, 0.3) !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(4)
  .v-expansion-panel-header:hover
  .text-h6,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(4)
  .v-expansion-panel-header--active
  .text-h6 {
  color: #f59e0b !important;
  font-weight: 700 !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(4)
  .v-expansion-panel-header:hover
  .v-icon,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(4)
  .v-expansion-panel-header--active
  .v-icon {
  color: #f59e0b !important;
  background: white !important;
  border-radius: 50% !important;
  border: 4px solid #f59e0b !important;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.08);
}
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(2)
  .v-expansion-panel-header:hover,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(2)
  .v-expansion-panel-header--active {
  border-color: #a855f7 !important;
  box-shadow: 0 12px 32px rgba(168, 85, 247, 0.3) !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(2)
  .v-expansion-panel-header:hover
  .text-h6,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(2)
  .v-expansion-panel-header--active
  .text-h6 {
  color: #a855f7 !important;
  font-weight: 700 !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(2)
  .v-expansion-panel-header:hover
  .v-icon,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(2)
  .v-expansion-panel-header--active
  .v-icon {
  color: #a855f7 !important;
  background: white !important;
  border-radius: 50% !important;
  border: 4px solid #a855f7 !important;
  box-shadow: 0 2px 8px rgba(168, 85, 247, 0.08);
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(4)
  .v-expansion-panel-header:hover,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(4)
  .v-expansion-panel-header--active {
  border-color: #f97316 !important;
  box-shadow: 0 12px 32px rgba(249, 115, 22, 0.3) !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(4)
  .v-expansion-panel-header:hover
  .text-h6,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(4)
  .v-expansion-panel-header--active
  .text-h6 {
  color: #f97316 !important;
  font-weight: 700 !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(4)
  .v-expansion-panel-header:hover
  .v-icon,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(4)
  .v-expansion-panel-header--active
  .v-icon {
  color: #f97316 !important;
  background: white !important;
  border-radius: 50% !important;
  border: 4px solid #f97316 !important;
  box-shadow: 0 2px 8px rgba(249, 115, 22, 0.08);
}

/* ==================== Utility Classes ==================== */
.btn-w {
  width: 100% !important;
}

/* ==================== Responsive Adjustments ==================== */
@media (max-width: 768px) {
  ::v-deep .v-expansion-panel-header {
    padding: 14px 16px !important;
    min-height: 56px !important;
  }

  ::v-deep .v-expansion-panel-header .text-h6 {
    font-size: 1rem !important;
  }

  ::v-deep .v-chip {
    font-size: 0.85rem !important;
    height: 32px !important;
    padding: 0 12px !important;
  }
}
.progress-bar-container {
  position: relative;
  width: 100%;
}

::v-deep .rainbow-progress .v-progress-linear__determinate {
  background: v-bind(progressBarBackground) !important;
  transition: all 0.3s ease;
}

::v-deep .rainbow-progress .v-progress-linear__background {
  background: #e5e7eb !important;
}
.section-skipped {
  opacity: 0.6;
}

::v-deep .section-skipped .v-expansion-panel-header {
  background-color: #f5f5f5 !important;
}
.dcolumn {
  display: flex;
  flex-direction: column;
}
</style>
